import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faSearch, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faTiktok, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import '../styles/Etusivu.css';
import EmailForm from '../components/EmailForm';
import Timeline from '../components/Timeline';
import NewsletterPopup from '../components/NewsletterPopup';
import { useTranslations } from '../hooks/useTranslations';

const Etusivu = () => {
  const [showLinks, setShowLinks] = useState(false);
  const { t } = useTranslations();

  return (
    <>
      <section id="hero" className="etusivu" aria-labelledby="hero-heading">
        <div className="hero-backdrop" aria-hidden="true">
          <video
            className="hero-video"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
          >
            <source src="background-video.mp4" type="video/mp4" />
          </video>
          <div className="hero-backdrop-overlay" />
        </div>
        <div className="hero-inner">
          <Navbar showLinks={showLinks} setShowLinks={setShowLinks} />
          <div className="firstpage">
            <div className="text-container-etusivu">
              <h1 id="hero-heading">{t('hero.heading', 'Täydellinen paikka lääketieteelliselle matkallesi')}</h1>
              <p>{t('hero.description', 'Paikka jossa tuemme, ohjaamme ja mentoroimme koko sydämestämme lääketieteen alalle pyrkiviä kollegoita.')}</p>
              <div className="hero-quote">
                <p>{t('hero.quote', '"Siellä missä lääketieteen taidetta rakastetaan, siellä rakastetaan myös ihmiskuntaa" - Hippocrates')}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-socials" aria-label="Seuraa meitä">
          <a
            href="https://www.facebook.com/TuutoriKeskus"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('hero.socials.facebook', 'TuutoriKeskus Facebookissa')}
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a
            href="https://www.instagram.com/tuutorikeskus/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('hero.socials.instagram', 'TuutoriKeskus Instagramissa')}
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a
            href="https://www.tiktok.com/@tuutorikeskus"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('hero.socials.tiktok', 'TuutoriKeskus TikTokissa')}
          >
            <FontAwesomeIcon icon={faTiktok} />
          </a>
          <a
            href="https://wa.me/358442447576"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('hero.socials.whatsapp', 'Ota yhteyttä WhatsAppissa')}
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </a>
        </div>
      </section>

      <div className='screen'>
        <div className="content-background">
          {/* Palvelumme Section */}
          <div className="palvelumme">
            <h1>{t('services.heading', 'Palvelumme')}</h1>
            <div className='card-container'>
              <div className="server-card">
                <div className="icon-frame">
                  <FontAwesomeIcon icon={faBook} className="card-logo" />
                </div>
                <h2>{t('services.cards.courses.title', 'Kurssit')}</h2>
                <p>{t('services.cards.courses.description', 'Valmennuskursseillamme koulutamme tulevia kollegoitamme suoriutumaan erinomaisesti pääsykokeissa. Opetusmenetelmämme ja pääsykokeeseen liittyvät neuvot ovat jo vuosien ajan osoittautuneet kursseillamme korvaamattomiksi.')}</p>
              </div>

              <div className="server-card">
                <div className="icon-frame">
                  <FontAwesomeIcon icon={faSearch} className="card-logo" />
                </div>
                <h2>{t('services.cards.application.title', 'Hakuprosessi')}</h2>
                <p>{t('services.cards.application.description', 'Paranna pääsymahdollisuuksiasi ulkoistamalla paperityöt ammattilaisille. Toimitamme hakupaperisi puolestasi Romanian yliopistoon, jolloin voit keskittyä täysin lukemiseen ja pääsykokeessa menestymiseen.')}</p>
              </div>

              <div className="server-card">
                <div className="icon-frame">
                  <FontAwesomeIcon icon={faPhone} className="card-logo" />
                </div>
                <h2>{t('services.cards.support.title', 'Asiakaspalvelu')}</h2>
                <p>{t('services.cards.support.description', 'Ajatus ulkomailla opiskelusta herättää usein vaikeita kysymyksiä siksi olemme täällä sinua varten. Otathan meihin yhteyttä, jos sinulla on kysyttävää palveluistamme tai Romanian lääketieteellisestä koulutusohjelmasta.')}</p>
              </div>
            </div>
          </div>

          <Timeline />

          {/* Lisätiedot Section */}
          <div className="lisa-tietoa">
            <h1>{t('moreInfo.heading', 'Lisätiedot')}</h1>
            <div className='info-card-container'>
              <div className="info-card">
                <div className="pic-frame">
                  <img src="Meistä1.jpg" alt={t('moreInfo.cards.about.alt', 'TuutoriKeskuksen tiimi')} className="card-pic-meistä-small" loading="lazy" />
                </div>
                <h2>{t('moreInfo.cards.about.title', 'Meistä')}</h2>
                <p>{t('moreInfo.cards.about.description', 'Me haluamme olla nuorten tukena elämän tärkeimmän polun valitsemisessa sekä haaveiden toteuttamisessa ja tätä kautta luoda lisäarvoa tuleville kollegoille.')}</p>
                <div className="card-links1">
                  <Link to="/Meistä" aria-label={t('moreInfo.cards.about.linkAria', 'Lue lisää meistä')}>
                    {t('common.links.readMore', 'Lue Lisää')}
                  </Link>
                </div>
              </div>

              <div className="info-card">
                <div className="pic-frame">
                  <img src="lääketiede-small.jpeg" alt={t('moreInfo.cards.medicine.alt', 'Opiskelija Romaniassa')} className="card-pic-lääketiede-small" loading="lazy" />
                </div>
                <h2>{t('moreInfo.cards.medicine.title', 'Lääketiede Romaniassa')}</h2>
                <p>{t('moreInfo.cards.medicine.description', 'Opinnot ovat käytännönläheisiä. Ensimmäiset vuodet keskittyvät teoriaan (prekliininen vaihe), kun taas viimeiset kolme vuotta sisältävät intensiivistä työkokemusta (postkliininen vaihe).')}</p>
                <div className="card-links2">
                  <Link to="/LääketiedeRomaniassa" aria-label={t('moreInfo.cards.medicine.linkAria', 'Lue lisää lääketieteen opinnoista Romaniassa')}>
                    {t('common.links.readMore', 'Lue Lisää')}
                  </Link>
                </div>
              </div>

              <div className="info-card">
                <div className="pic-frame">
                  <img src="tentti-small.jpeg" alt={t('moreInfo.cards.requirements.alt', 'Tentteihin valmistautuva opiskelija')} className="card-pic-lääketiede-small" loading="lazy" />
                </div>
                <h2>{t('moreInfo.cards.requirements.title', 'Tenttivaatimukset')}</h2>
                <p>{t('moreInfo.cards.requirements.description', 'Romaniassa huippuyliopistot eivät vaadi kemiaa tai fysiikkaa. Pääsykokeissa keskitytään anatomiaan ja fysiologiaan. Koe on pääpainoitteisesti suullinen.')}</p>
                <div className="card-links3">
                  <Link to="/Tenttivaatimukset" aria-label={t('moreInfo.cards.requirements.linkAria', 'Lue lisää tenttivaatimuksista')}>
                    {t('common.links.readMore', 'Lue Lisää')}
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Ota Yhteyttä Section */}
          <EmailForm />
        </div>

        <NewsletterPopup />
      </div>
    </>
  );
};

export default Etusivu;
